import { defineComponent as y, computed as F, openBlock as o, createElementBlock as n, createElementVNode as e, createVNode as C, unref as i, withCtx as p, Fragment as c, renderList as _, createBlock as f, toDisplayString as d, mergeProps as w, createCommentVNode as b } from "vue";
import { Accordion as A, AccordionItem as L } from "./accordion.es.js";
import { _ as S } from "./chunks/CustomLink.vue_vue_type_style_index_0_lang.c7d27b7c.js";
import { l as V } from "./chunks/linkClickHandler.d9801523.js";
import './assets/index9.css';const $ = { class: "Footer" }, D = { class: "Footer__wrapper" }, E = { class: "Footer__sections" }, N = ["href", "target", "data-event", "onClick"], P = {
  key: 0,
  class: "Footer__socialLinks"
}, U = /* @__PURE__ */ e("div", { class: "Footer__socialLinks__title" }, "Follow us", -1), B = { class: "Footer__copyright" }, x = ["href"], T = /* @__PURE__ */ e("span", null, " | ", -1), Y = ["href"], z = /* @__PURE__ */ y({
  __name: "Footer",
  props: {
    copyright: {},
    privacyPolicyUrl: {},
    termsAndConditionsUrl: {},
    blocks: { default: () => new Array() },
    socialLinks: { default: () => new Array() }
  },
  setup(m) {
    const l = m, h = F(() => (/* @__PURE__ */ new Date()).getFullYear());
    function v(r, u) {
      V(r, u, typeof window > "u");
    }
    return (r, u) => (o(), n("footer", $, [
      e("div", D, [
        e("div", E, [
          C(i(A), {
            autoCollapsable: !1,
            showNumbers: !1
          }, {
            default: p(() => [
              (o(!0), n(c, null, _(l.blocks, (t, a) => (o(), f(i(L), {
                key: a,
                title: t.title
              }, {
                content: p(() => [
                  e("ul", null, [
                    (o(!0), n(c, null, _(t.links, (s, g) => (o(), n("li", {
                      key: "l" + g
                    }, [
                      e("a", {
                        href: s.url,
                        target: s.target,
                        "data-event": r.$ga.getDataEventValue(
                          "footer",
                          ["block", a.toString()],
                          ["a", s.text]
                        ),
                        onClick: (k) => v(s, k)
                      }, d(s.text), 9, N)
                    ]))), 128))
                  ])
                ]),
                _: 2
              }, 1032, ["title"]))), 128))
            ]),
            _: 1
          }),
          r.socialLinks.length ? (o(), n("div", P, [
            U,
            (o(!0), n(c, null, _(l.socialLinks, (t, a) => (o(), f(i(S), w({ key: a }, t, {
              "data-event": r.$ga.getDataEventValue("footer", t.icon || t.link.text, [
                "a",
                t.hiddenText.toString()
              ])
            }), null, 16, ["data-event"]))), 128))
          ])) : b("", !0)
        ]),
        e("div", B, [
          e("div", null, [
            e("span", null, "© " + d(h.value) + " " + d(l.copyright), 1)
          ]),
          e("div", null, [
            e("a", {
              href: r.privacyPolicyUrl,
              target: "_blank"
            }, "Privacy policy", 8, x),
            T,
            e("a", {
              href: r.termsAndConditionsUrl,
              target: "_blank"
            }, "Terms and conditions", 8, Y)
          ])
        ])
      ])
    ]));
  }
});
export {
  z as Footer
};
